import surveyService from "../../services/surveyService";

function load({ dispatch, commit }, id) {
  return new Promise((resolve, reject) => {
    commit("setPendingStateChanges", 1);

    dispatch("getSurvey", id)
      .then(result => {
        commit("set", result);
        resolve(JSON.parse(JSON.stringify(result)));
      }, reject)
      .finally(() => {
        commit("setPendingStateChanges", -1);
      });
  });
}

const getSurvey = ({ rootState }, id) =>
  surveyService.get(rootState.tenantId, id);

const getAggregate = (
  { state, rootState },
  { key, groupedBy, surveyId } = {}
) =>
  surveyService.getAggregate(
    rootState.tenantId,
    surveyId ? surveyId : state.id,
    key,
    groupedBy
  );

const getCodeStats = ({ state, rootState }) =>
  surveyService.getCodeStats(rootState.tenantId, state.id);

export default {
  load,
  getSurvey,
  getCodeStats,
  getAggregate
};
